module.exports = __webpack_public_path__ + "static/media/parallelogram_angle0_split.37ff285a.svg";